<template>
<div :id="uid" :class="`h-zone ${showZone ? 'show' : ''}`">

    <div class="h-zone-counter" ref="counter" :style="inverted ? {right: 0} : {left: 0}">{{cards.length}}</div>
    <div style="position: absolute; right: 0px; bottom: 0">
        <button class="btn-action" style="padding: 0.5vw" v-if="!private" @click="ToggleZoneVisibility">{{!showZone ? 'O' : 'Ø'}}</button>
        <button class="btn-action" style="padding: 0.5vw" v-if="!private" @click="Shuffle">↺</button>
    </div>
</div>
</template>

<script>
import interact from 'interactjs'
export default {
    props: {
        uid: {type: String, default: ''},
        height: {type: Number, default: 0},
        width: {type: Number, default: 0},
        private: {type: Boolean, default: false},
        inverted: {type: Boolean, default: false},
        downTarget: {type: String, default: null},
        upTarget: {type: String, default: null},
        leftTarget: {type: String, default: null},
        rightTarget: {type: String, default: null},
    },
    data() {
        return {
            cards: [],
            showZone: false,
            autoPosition: true,
        }
    },
    mounted() {
        let t = this;
        interact(this.$el).dropzone({
            ondrop: this.OnDrop
        })
    },
    methods: {
        Reset() {
            this.showZone = false;
            this.cards = [];
            this.Update();
        },
        OnDrop(e) {
            let card = e.relatedTarget;
            if(card && card.__vue__)
            {
                this.AttachCard(card.__vue__);
                this.$socket.client.emit('AttachCard', {parent: this.uid, card: card.__vue__.uid});
            }
        },
        AttachCard(card)
        {
            let arrCards = [card];
            arrCards = arrCards.concat(card.childs);
            card.childs = [];

            arrCards.forEach(c => {
                this.cards.push(c);
                c.SetParent(this);
            });

            this.Update();
        },
        DeattachCard(card) {
            for(let i = 0; i < this.cards.length; i++)
            {
                if(card == this.cards[i])
                {
                    this.cards.splice(i, 1);
                    break;
                }
            }
            card.parent = null;
            this.Update();
        },
        Update() {
            let rectArena = document.getElementById('arena').getBoundingClientRect();
            let rect = this.$el.getBoundingClientRect();
            //console.log(rect);
            for(let i = 0; i < this.cards.length; i++)
            {
                let card = this.cards[i];
                card.hidden = this.hidden;
                if(this.autoPosition)
                {
                    let x = (((rect.x - rectArena.x) + (this.width * 3.5) + (this.width*1.1*i)) * 100) / rectArena.width;
                    if(this.inverted) x = (rectArena.width - this.width - (this.width * 3.5) - (this.width*1.1*i)) * 100 / rectArena.width;
                    
                    let y = (rect.y - rectArena.y) * 100 / rectArena.height;
                    if(this.inverted) y = (rectArena.y - rect.y - (this.height - rect.height)) * 100 / rectArena.height;
                    card.Move(x, y);
                }
                this.cards[i].$el.classList.remove('no-transition');
            }
        },
        ToggleZoneVisibility() {
            this.showZone = !this.showZone;
            this.Update();
            this.$socket.client.emit('ShowZone', {id: this.uid, show: this.showZone});
        },
        Shuffle()
        {
            if(this.private) return;
            let tmp = this.cards.map(value => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value);
            
            let order = [];
            tmp.forEach(card => {
                order.push(card.uid);
            });
            this.ShuffleByIds(order);
            this.$socket.client.emit('ShufflePile', {id: this.uid, order: order});

        },
        ShuffleByIds(uids)
        {
            let ordered = [];
            uids.forEach(uid => {
                let c = this.cards.find(card => {
                    return card.uid == uid;
                });
                ordered.push(c);
            });
            this.cards = ordered;
            this.Update();
            this.$refs.counter.classList.remove('pile-shake');
            setTimeout(() => {
                this.$refs.counter.classList.add('pile-shake');
            }, 10);
            return;
        },
    },
    computed: {
        hidden() {
            return this.private && !this.showZone;
        }
    }
}   
</script>

<style>
.h-zone {
    position: relative;
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
}
.h-zone-counter {
    color: rgba(255, 255, 255, 0.5);
    font-size: 1.5vw;
    text-shadow: 0px 0px 10px black;
    position:absolute;
    padding: 0.5vw;
}
</style>